import axios from 'axios';
import curlirize from 'axios-curlirize';
import { adminAPI } from 'services/admin';
import getMetadata from './metadata';

const Axios = axios.create({});

curlirize(Axios);

export class Upload {
  constructor(options) {
    // this must be bigger than or equal to 5MB
    this.chunkSize = options.chunkSize || 1024 * 1024 * 1000;
    // number of parallel uploads
    this.threadsQuantity = Math.min(options.threadsQuantity || 10);
    this.file = options.file;
    this.fileName = options.fileName;
    this.aborted = false;
    this.uploadedSize = 0;
    this.percentageValue = 0;
    this.progressCache = {};
    this.activeConnections = {};
    this.parts = [];
    this.uploadedParts = [];
    this.uploadId = null;
    this.fileKey = null;
    this.onProgressFn = () => { };
    this.onErrorFn = () => { };
    this.onFinishFn = () => { };
    this.apiName = options.apiName;
    this.path = options.path;
    this.token = options.token;
    this.id = options.id;
    this.language = options.language;
    this.userId = options.userId;
    this.userName = options.userName;
    this.setIsLoading = options.setIsLoading;
    this.setProps = options.setProps;
    this.setNotify = options.setNotify;
    this.type = options.type;
    this.getValues = options.getValues;
    this.setValue = options.setValue;
    this.languages = options.languages;
    this.setMainUploaded = options.setMainUploaded;
    this.setTrailerUploaded = options.setTrailerUploaded;
    this.setAccessibilityUploaded = options.setAccessibilityUploaded;
    this.setAuth = options.setAuth;
    this.mediaContentType = options.mediaContentType;
    this.setDuration = options.setDuration;
    this.nameIsAcessibilityCheck = options.nameIsAcessibilityCheck;
    this.isChecked = options.isChecked;
    this.accessibility = options.accessibility;
  }

  start() {
    this.initialize();
  }

  async loadVideo(file) {
    new Promise((resolve, reject) => {
      try {
        let video = document.createElement('video');
        video.preload = 'metadata';

        video.onloadedmetadata = function () {
          resolve(this);
        };

        video.onerror = function () {
          reject('Invalid video. Please select a video file.');
        };

        video.src = window.URL.createObjectURL(file);
      } catch (e) {
        reject(e);
      }
    });
  }

  async getUrl() {
    return new Promise(resolve => {
      // const ext = this.file.name.split(".").pop();
      // if (this.file.size >= 10000000000) {
      //   alert("A mídia não pode exceder 10 GB.");
      //   return;
      // }
      const numberOfparts = Math.ceil(this.file.size / this.chunkSize);
      // console.log('this.file.size',this.file.size)
      // console.log('this.chunkSize',this.chunkSize)
      // console.log('1024 * 1024 * 5', 1024 * 1024 * 5)

      let data = null;
      let duration = null;

      if (this.type.label === 'video') {
        if (this.type.name === 'MAIN') {
          this.mainName = this.file.name;
        }

        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = window.URL.createObjectURL(this.file);
        this.setValue('duration', video.duration);
        // this.setDuration(video.duration)

        data = {
          body: {
            duration: duration,
            mediaType: this.type.name,
            mediaContentType: this.mediaContentType || 'VIDEO',
            mediaContentId: this.id,
            audioLanguage: this.language?.value,
            fileDataType: this.file.type,
            drm: true,
            extension: this.file.name.substring(
              this.file.name.indexOf('.') + 1
            ),
            drmProvider: 'CASTLABS',
            fileName: this.file.name,
            distributionRegion: 'sa-east-1',
            partsUpload: numberOfparts,
            processOnUpload: false,
            createdBy: {
              userId: this.userId,
              name: this.userName,
            },
          },
          headers: {
            Authorization: `${this.token}`,
          },
        };
      }

      if (this.type.label === 'legenda') {
        let selectedSubtitle = this.language;
        if (!selectedSubtitle?.label) {
          this.languages
            .filter(lang => lang.uuid === selectedSubtitle.value)
            .forEach(filteredLang => {
              this.setValue(`${this.name}`, {
                value: filteredLang.uuid,
                label: filteredLang.name,
              });
            });
          selectedSubtitle = this.language;
        }

        data = {
          body: {
            fileName: this.file.name,
            parts: numberOfparts,
            mimeType: 'text/plain',
            extension: this.file.name.substring(
              this.file.name.indexOf('.') + 1
            ),
            accessibility: this.isChecked,
            language: selectedSubtitle.value,
          },
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${this.token}`,
          },
        };
      }
      if (this.type.label === 'audio') {
        this.audioMainName = this.file.name;
        data = {
          body: {
            fileName: this.file.name,
            parts: numberOfparts,
            mimeType: this.file.type,
            extension: this.file.name.substring(
              this.file.name.indexOf('.') + 1
            ),
            accessibility: this.isChecked,
            language: this.language.value,
          },
        };
      }

      adminAPI
        .post(this.path, data)
        .then(resp => {
          // console.log("data", data);
          // console.log("res", resp);
          this.setIsLoading(false);
          resolve(resp);
        })
        .catch(error => {
          this.setIsLoading(false);
          console.log(error);
        });
    });
  }
  async initialize() {
    try {
      const urlResponse = await this.getUrl();

      this.uploadId = urlResponse.multipartUpload.uploadId;
      this.fileKey = urlResponse.multipartUpload.fileKey;

      this.audioTrackId = urlResponse?.audioTrackId;

      if (this.type.label === 'legenda') {
        if (this.type.name === 'ACCESSIBILITY') {
          this.accessibilityLegenda = {
            type: 'LEGENDA',
            description: this.file.name,
            name: this.file.name,
            percent: 0,
            id: urlResponse?.mediaId,
            accessibility: this.isChecked,
          };
          this.setValue(`${this.name}`, this.accessibilityLegenda);
          this.setProps(prevState => [
            ...prevState,
            {
              name: this.file.name,
              mediaId: urlResponse.mediaId,
              subtitleId: urlResponse.subtitleId,
              label: this.language?.label,
              accessibility: this.isChecked,
            },
          ]);
        }
        if (this.type.name === 'TRAILER') {
          this.trailerLegenda = {
            type: 'LEGENDA',
            description: this.file.name,
            name: this.file.name,
            percent: 0,
            id: urlResponse?.mediaId,
            accessibility: this.isChecked,
          };
          this.setValue(`${this.name}`, this.trailerLegenda);
          let label = this.getValues('subtitle_trailer_language');
          this.setProps(prevState => [
            ...prevState,
            {
              name: this.file.name,
              mediaId: urlResponse.mediaId,
              subtitleId: urlResponse.subtitleId,
              label: label?.label,
              accessibility: this.isChecked,
            },
          ]);
        }
        if (this.type.name === 'MAIN') {
          this.mainLegenda = {
            type: 'LEGENDA',
            description: this.file.name,
            name: this.file.name,
            percent: 0,
            id: urlResponse?.mediaId,
            accessibility: this.isChecked,
          };
          this.setValue(`${this.name}`, this.mainLegenda);
          let label = this.getValues('subtitle');
          this.setProps(prevState => [
            ...prevState,
            {
              name: this.file.name,
              mediaId: urlResponse.mediaId,
              subtitleId: urlResponse.subtitleId,
              label: label?.label,
              accessibility: this.isChecked,
            },
          ]);
        }
      }
      if (this.type.label === 'video' && this.type.name === 'MAIN') {
        this.mainVideo = {
          type: 'MAIN',
          description: 'vídeo principal',
          name: this.mainName,
          percent: 0,
          id: urlResponse?.mediaId,
          isFinished: this.mainFinished,
          accessibility: this.isChecked,
        };

        this.setValue('mediaId', urlResponse?.mediaId);
        let label = this.getValues('video_language');
        this.setProps(prevState => ({
          ...prevState,
          mediaId: {
            mediaType: this.type.name,
            mediaId: urlResponse?.mediaId,
            name: this.file.name,
            label: label?.label,
            accessibility: this.isChecked,
          },
        }));
      }
      if (this.type.label === 'audio') {
        this.mainAudio = {
          type: 'audio',
          description: 'Áudio principal',
          name: this.audioMainName,
          percent: 0,
          id: urlResponse?.mediaId,
        };
        this.setProps(prevState => [
          ...prevState,
          {
            name: this.file.name,
            mediaId: urlResponse?.mediaId,
            audioTrackId: this.audioTrackId,
            label: this.language.label,
            accessibility: this.isChecked,
          },
        ]);
      }
      if (this.type.name === 'TRAILER' && this.type.label !== 'legenda') {
        this.trailer = {
          type: 'TRAILER',
          description: 'Trailer',
          name: this.file.name,
          id: urlResponse?.mediaId,
          percent: 0,
        };

        this.setValue('trailerId', urlResponse?.mediaId);
        this.setProps(prevState => ({
          ...prevState,
          trailer: {
            trailerId: urlResponse?.mediaId,
            mediaId: urlResponse?.mediaId,
            mediaType: this.type.name,
            name: this.file.name,
            accessibility: this.isChecked,
          },
        }));
      }
      if (this.type.name === 'ACCESSIBILITY' && this.type.label !== 'legenda') {
        this.acessibility = {
          type: 'ACCESSIBILITY',
          description: 'Acessibilidade',
          id: urlResponse?.mediaId,
          name: this.file.name,
          percent: 0,
        };
        this.setValue('mediaWithAcessibilityId', urlResponse?.mediaId);
        this.setProps(prevState => ({
          ...prevState,
          ACCESSIBILITY: {
            mediaWithAcessibilityId: urlResponse?.mediaId,
            mediaId: urlResponse?.mediaId,
            mediaType: this.type.name,
            name: this.file.name,
            accessibility: this.isChecked,
          },
        }));
      }

      const newParts = urlResponse.multipartUpload.parts;
      this.parts.push(...newParts);
      this.sendNext();
    } catch (error) {
      console.log(error);
      await this.complete(error);
    }
  }

  sendNext() {
    const activeConnections = Object.keys(this.activeConnections).length;
    // 1 turn -> 0 ativa - 5 threads
    if (activeConnections >= this.threadsQuantity) {
      return;
    }
    // Caso não tenha mais partes para serem uploads e não tiverem conexões ativas
    if (!this.parts.length) {
      if (!activeConnections) {
        console.log('Upload Completo.');
        this.complete();
      }
      return;
    }

    // Pop the first part
    const part = this.parts.pop();
    if (this.file && part) {
      const sentSize =
        ((part?.partNumber || part?.PartNumber) - 1) * this.chunkSize;

      const chunk = this.file.slice(sentSize, sentSize + this.chunkSize);

      const sendChunkStarted = () => {
        this.sendNext();
      };

      this.sendChunk(chunk, part, sendChunkStarted)
        .then(() => {
          this.sendNext();
        })
        .catch(error => {
          // Caso de erro, refaz a pedaço do upload novamente.
          this.parts.push(part);
          this.complete(error);
        });
    }
  }

  async complete(error) {
    if (error && !this.aborted) {
      this.onErrorFn(error);
      return;
    }

    if (error) {
      this.onErrorFn(error);
      return;
    }

    try {
      await this.sendCompleteRequest();
    } catch (error) {
      this.onErrorFn(error);
    }
  }

  async sendCompleteRequest() {
    if (this.uploadId && this.fileKey) {
      const metadata = await getMetadata(this.file);
      const videoFinalizationMultiPartInput = {
        uploadId: this.uploadId,
        fileKey: this.fileKey,
        parts: this.uploadedParts,
        metadata: metadata
      };
      console.log('Finishing the upload.');
      let data = {
        body: videoFinalizationMultiPartInput,
      };

      await adminAPI
        .post('/admin/multipart-upload-complete', data)
        .then(resp => {
          this.setIsLoading(false);
          this.setNotify({
            isOpen: true,
            message: resp.details
              ? `${resp.details}`
              : `${resp.message} do arquivo ${this.file.name}`,
            type: 'success',
            title: 'Sucesso!',
          });
          if (this.type.name === 'ACCESSIBILITY') {
            this.setAccessibilityUploaded(true);
          }
          if (this.type.name === 'TRAILER') {
            this.setTrailerUploaded(true);
          }
          if (this.type.name === 'MAIN') {
            this.setMainUploaded(true);
          }

          setTimeout(() => {
            this.onFinishFn();
          }, 2000);
        })
        .catch(error => {
          this.setIsLoading(false);
          console.log(error);
        });
    }
  }

  sendChunk(chunk, part, sendChunkStarted) {
    return new Promise((resolve, reject) => {
      this.upload(chunk, part, sendChunkStarted)
        .then(status => {
          if (status !== 200) {
            reject(new Error('Failed chunk upload'));
            return;
          }

          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  handleProgress(part, event) {
    if (this.file) {
      if (
        event.type === 'progress' ||
        event.type === 'error' ||
        event.type === 'abort'
      ) {
        this.progressCache[part] = event.loaded;
      }

      if (event.type === 'uploaded') {
        this.uploadedSize += this.progressCache[part] || 0;
        delete this.progressCache[part];
      }

      const inProgress = Object.keys(this.progressCache)
        .map(Number)
        .reduce((memo, id) => (memo += this.progressCache[id]), 0);

      const sent = Math.min(this.uploadedSize + inProgress, this.file.size);

      const total = this.file.size;

      const percentage = Math.round((sent / total) * 100);

      this.percentageValue = percentage;

      this.onProgressFn({
        sent: sent,
        total: total,
        percentage: percentage,
        name: this.file.name,
        mainVideo: this.mainVideo,
        mainAudio: this.mainAudio,
        acessibility: this.acessibility,
        trailer: this.trailer,
        mainLegenda: this.mainLegenda,
        accessibilityLegenda: this.accessibilityLegenda,
        trailerLegenda: this.trailerLegenda,
      });
    }
  }

  upload(file, part, sendChunkStarted) {
    // uploading each part with its pre-signed URL
    // console.log("uploading each part with its pre-signed URL")
    // console.log("part", part)
    //console.log("file", file)
    return new Promise((resolve, reject) => {
      if (this.uploadId && this.fileKey) {
        const xhr = (this.activeConnections[
          (part?.partNumber || part?.PartNumber) - 1
        ] = new XMLHttpRequest());

        sendChunkStarted();
        const progressListener = this.handleProgress.bind(
          this,
          (part?.partNumber || part?.PartNumber) - 1
        );

        xhr.upload.addEventListener('progress', progressListener);

        xhr.addEventListener('error', progressListener);
        xhr.addEventListener('abort', progressListener);
        xhr.addEventListener('loadend', progressListener);

        xhr.open('PUT', part.signedUrl);
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            const ETag = xhr.getResponseHeader('ETag');
            if (ETag) {
              const uploadedPart = {
                partNumber: part?.partNumber || part?.PartNumber,
                eTag: ETag.replaceAll('"', ''),
              };

              this.uploadedParts.push(uploadedPart);

              resolve(xhr.status);
              delete this.activeConnections[
                (part?.partNumber || part?.PartNumber) - 1
              ];
            }
          }
        };

        xhr.onerror = error => {
          reject(error);
          delete this.activeConnections[
            (part?.partNumber || part?.PartNumber) - 1
          ];
        };

        xhr.onabort = () => {
          reject(new Error('Upload canceled by user'));
          delete this.activeConnections[
            (part?.partNumber || part?.PartNumber) - 1
          ];
        };

        xhr.send(file);
      }
    });
  }

  onProgress(onProgress) {
    this.onProgressFn = onProgress;
    return this;
  }

  onError(onError) {
    this.onErrorFn = onError;
    return this;
  }

  onFinish(onFinish) {
    this.onFinishFn = onFinish;
    return this;
  }

  abort() {
    Object.keys(this.activeConnections)
      .map(Number)
      .forEach(id => {
        // console.log('id', id)
        // console.log('file', this.file)
        this.activeConnections[id].abort();
      });

    this.aborted = true;
  }
}
